import { css } from '@emotion/core';
import styled from '@emotion/styled';
import Img from 'components/atoms/img';
import { TextSet } from 'components/molecules/textSet';
import React from 'react';
import { contentWrapper } from 'style/mixin';
import sizes from 'style/sizes';
import { mq, headerHeightPc } from 'style/variables';

type DetailContentProps = {
  imgs: Array<ImgsObject>;
  isImgRight?: boolean;
};

export type ImgsObject = {
  path: string;
  alt: string;
};

const Container = styled.div<DetailContentProps>`
  opacity: 1;
  ${props => props.isImgRight && `flex-direction: row-reverse`};
  ${mq.onlypc} {
    ${contentWrapper}
    display: flex;
    margin-bottom: ${sizes.margin[180]};
  }
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[100]};
  }
`;

const ImageWrapper = styled.div<DetailContentProps>`
  ${mq.onlypc} {
    min-width: ${(680 / 1160) * 100}%;
    ${props =>
      props.isImgRight
        ? css`
            margin-left: 80px;
            margin-right: calc((1160px - 100vw) / 2);
          `
        : css`
            margin-right: 80px;
            margin-left: calc((1160px - 100vw) / 2);
          `}
  }
  ${mq.onlypcmin} {
    ${props => (props.isImgRight ? `margin-right` : `margin-left`)}: -40px;
  }
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[64]};
  }
  & > div {
    & + div {
      margin-top: 1px;
    }
  }
`;

const TextArea = styled.div`
  position: relative;
  ${mq.onlysp} {
    padding: 0 ${sizes.margin[32]};
  }
`;

const TextAreaInner = styled.div`
  ${mq.onlypc} {
    position: sticky;
    top: ${headerHeightPc}px;
  }
`;

export const DetailContent: React.FC<DetailContentProps> = props => {
  return (
    <Container {...props}>
      <ImageWrapper {...props}>
        {props.imgs?.map((item, idx) => (
          <Img key={idx} filename={item.path} alt={item.alt} />
        ))}
      </ImageWrapper>
      <TextArea>
        <TextAreaInner>
          <TextSet>{props.children}</TextSet>
        </TextAreaInner>
      </TextArea>
    </Container>
  );
};
